import 'store/bolt/showtimesLoader';
import Store from 'store/store';

Store.on('SHOWTIMES_SHOW', (animate, queryString, pageId) => {
	const store = Store.get();
	let returnTo = store.activePage;
	if (pageId && returnTo === pageId) {
		// Landing directly on a showtimes page - assume there is a matching event page
		returnTo = pageId.replace(/-showtimes$/i, '');
	}
	store.showtimes.set({ returnToPage: returnTo });
	store.homeEnt.set({ returnToPage: returnTo });
});
